<template>
  <Dialog
    v-model:visible="isVisible"
    header="Change Workspace"
    @hide="hide()"
    @show="show()"
    :dismissable="false"
    :draggable="false"
    :modal="true"
    :style="{ width: '40vw' }"
  >
    <span v-show="errMessage" class="p-error">{{ errMessage }}</span>

    <div class="p-inputtext-sm p-fluid mt-3">
      <FormField
        :labelName="$t('work_space')"
        fieldName="CompanyCode"
        v-model="changeProfileUser"
        labelClass="col-4"
        fieldClass="col-12 md-6"
      >
        <CustomSelect
          v-model="changeProfileUser.CompanyCode"
          v-if="changeProfileUser"
          :url="this.$API_URL + 'list/workspace_user'"
          :minLength="0"
          :filter="true"
          :params="{ userId: this.userid, companyCode: this.coyCodeUser }"
        />
      </FormField>
    </div>

    <template #footer>
      <Button
        type="button"
        icon="pi pi-save"
        class="p-button p-button-success"
        :disabled="disableButton"
        @click="updateProfile()"
        label="Save"
      />
    </template>
  </Dialog>
</template>
<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength, sameAs, requiredIf } from "@vuelidate/validators";

export default {
  data() {
    return {
      v$: useVuelidate(),
      errMessage: null,
      url: this.$API_URL + "auth/update_user",
      companyId: this.$store.getters.getCompanyId,
      modelPassword: null,
      disableButton: false,
      fullname: this.$store.getters.getFullname,
      emailuser: this.$store.getters.getEmail,
      phoneuser: this.$store.getters.getPhone,
      deptuser: this.$store.getters.getDeptId,
      username: this.$store.getters.getUsername,
      userid: this.$store.getters.getUserId,
      coyCodeUser: this.$store.getters.getCompanyCode,
      modeChange: "Work Space",
      coyCodeSupply: null,
      editorPath: "/User/Editor",
      resetPassword: {
        currentPass: null,
        pass: null,
        confirmPass: null,
      },
      changeProfileUser: {
        Id: null,
        CompanyCode: null,
        mode: null,
      },
    };
  },
  validations() {
    return {
      changeCompany: {
        coy: { required },
      },
    };
  },
  props: {
    model: {
      type: Object,
      default: null,
    },
    userId: {
      type: String,
      default: null,
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    requireCompany: {
      type: Boolean,
      default: false,
    },
    initialErrorMessage: {
      type: String,
      default: "",
    },
    changeFirstLogin: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    show() {
      this.$emit("toggle-changeworkspace");
      this.changeProfileUser.CompanyCode = this.coyCodeUser;
      this.changeProfileUser.Id = this.userid;
      this.changeProfileUser.mode = this.modeChange;
      if (this.initialErrorMessage) {
        this.errMessage = this.initialErrorMessage;
      }
    },
    hide(changeSuccess, message) {
      this.resetPassword = {
        pass: null,
        confirmPass: null,
      };
      this.v$.$reset();
      this.errMessage = null;
      this.$emit("update:isVisible", false);
      this.$emit("hide", {
        success: changeSuccess,
        message: message,
      });
    },
    passwordClass(data) {
      if (data.showPassword == undefined) {
        data.showPassword = "pi pi-eye";
      }
      data.showPassword =
        data.showPassword == "pi pi-eye-slash" || data.showPassword == undefined
          ? "pi pi-eye"
          : "pi pi-eye-slash";
      return data.showPassword;
    },
    passwordType(data) {
      return data == "pi pi-eye" ? "pi pi-eye-slash" : "pi pi-eye";
    },
    changecoy(e) {
      //console.log(e)
      this.coyCodeSupply = e == null ? null : e.code;
    },
    updateProfile() {
      this.disableButton = true;
      var self = this;
      this.$emit("block-ui");

      this.$axios
        .post(this.url, this.changeProfileUser)
        .then((response) => {
          if (response.data.success) {
            //this.$router.push({ path:  "/Work/Editor" , query: { mode: "Edit", id: id } });
            self.$store.dispatch("login", response.data.data);
            self.$axios.defaults.headers.common["Authorization"] =
              response.data.data.user_data.Token;
            self.$emit("update:model", this.model);
            self.hide(true, response.data.message);

            self.$nextTick(() => {
              window.location.reload();
            }); 

            // self.$router.push("/");
          } else {
            this.errMessage = "Failed: " + response.data.message;
          }
          self.$emit("unblock-ui");
          self.disableButton = false;

           self.$nextTick(() => {
            window.location.reload();
          }); 
        })
        .catch((err) => {
          self.disableButton = false;
          self.$emit("unblock-ui");
          self.$toast.add({
            severity: "error",
            summary: "Error",
            detail: err.message,
            life: 3000,
          });
        });
    },
  },
  emits: ["hide", "block-ui", "unblock-ui"],
};
</script>
